export default __webpack_public_path__ + "static/media/easyProcess.5924b867.svg";